import React from "react";
import { EqualIconSmall, TextValueTable1, TextValueTable2 } from "../styles";
import styled from "styled-components";
import { dateFormat, getCoinCodeImage } from "../../../utils/helper";
import { useApp } from "../../../contexts";

const Wraper = styled.div`
  border-top: 1px solid #f2efef;
  &:first-child {
    border-top: unset;
  }
`;

export const WalletRowItemSOT = ({
  coin,
  marketPrice,
  amount,
  local,
  onClick,
  SourceCoin,
  className,
  item,
  onClaim
}) => {
  const { T } = useApp();
  return (
    <Wraper
      className={`flex justify-between py-[5px] ${className}`}
      onClick={() => onClick?.()}
    >
      <div className="flex flex-wrap items-center gap-x-3">
        <div>
          <img
            alt=""
            style={{ width: 28, height: 28 }}
            src={`/assets/images/otc/crypto/${getCoinCodeImage(
              coin
            )?.toLowerCase()}.svg`}
          />
        </div>
        <div>
          <div className="flex">
            <TextValueTable1>{coin}</TextValueTable1>
            {SourceCoin}
          </div>
          
          {item.claimableBalance > 0 ? <div className="">
            <button type="button"
              className="bg-black text-[14px] font-semibold rounded-[15px] min-w-[60px] h-[18px]"
              onClick={(e) => {e.stopPropagation();onClaim(item)}}
            >
              <div className="bg-black px-[10px] w-[calc(100%-2px)] flex items-center justify-center mx-[1px] h-[calc(100%-2px)] my-[1px] rounded-[15px]">
                <span className="text-white text-[10px] font-semibold">{T('Claim')}</span>
              </div>
            </button>
          </div>: <span className="text-[#8C8D99] text-[10px] font-light">{T("Release On")} {dateFormat(item.releaseTime, 'YYYY/MM/DD')}</span> }
          {/* <TextValueTable2 className="mt-[4px]">{marketPrice}</TextValueTable2> */}
        </div>
      </div>
      <div className="ml-[12px]">
        <TextValueTable1 className="text-right">{amount}</TextValueTable1>
        <TextValueTable2 className="text-right mt-[4px] flex items-center w-full justify-end gap-2">
          <EqualIconSmall />
          {local}
        </TextValueTable2>
      </div>
    </Wraper>
  );
};